<template>
    <create-account></create-account>
</template>

<script>
import CreateAccount from '@/components/auth/createAccount';
export default {
    name: 'CreateUserPage',
    components: { CreateAccount },
};
</script>

<style scoped></style>
